import { AddressBlock } from "./AddressBlock";
import { clipDateYear } from "./dateUtils";
import { DateField } from "./DateField";
import { TitelSelect } from "./TitelSelect";

/**
 * Person 2 for Eheleute Anrede.
 *
 * value shape:
 *  { titel, vorname, name, geburtsdatum, use_main_address, strasse, hausnummer, plz, ort, country_code }
 */
export const Person2Fields = ({ value, onChange, searchPlaces }) => {
  const set = (k) => (v) => onChange({ ...value, [k]: v });

  const p2Address = {
    strasse: value.strasse || "",
    hausnummer: value.hausnummer || "",
    plz: value.plz || "",
    ort: value.ort || "",
    country_code: value.country_code || "DE",
  };
  const onP2AddressChange = (next) =>
    onChange({
      ...value,
      strasse: next.strasse,
      hausnummer: next.hausnummer,
      plz: next.plz,
      ort: next.ort,
      country_code: next.country_code,
    });

  return (
    <div className="space-y-5">
      <div className="grid sm:grid-cols-2 gap-5">
        <TitelSelect
          id="p2-titel"
          value={value.titel}
          onChange={set("titel")}
        />
        <div /> {/* spacer */}
        <Field
          id="p2-vorname"
          label="Vorname *"
          value={value.vorname}
          onChange={set("vorname")}
        />
        <Field
          id="p2-name"
          label="Name *"
          value={value.name}
          onChange={set("name")}
        />
        <DateField
          id="p2-geburtsdatum"
          label="Geburtsdatum"
          required
          value={value.geburtsdatum}
          onChange={set("geburtsdatum")}
          className="sm:col-span-2"
        />
      </div>

      <div className="pt-4 border-t border-[#e8e6df]">
        <label className="flex items-start gap-3 cursor-pointer select-none">
          <input
            type="checkbox"
            data-testid="form-input-p2-use-main-address"
            checked={value.use_main_address}
            onChange={(e) => set("use_main_address")(e.target.checked)}
            className="mt-1 w-4 h-4 accent-[#d90429]"
          />
          <span className="text-[14px] text-[#0a1128]">
            <strong>Adresse von Person 1 übernehmen.</strong>
            <span className="block text-[#505a74] text-[13px] mt-0.5">
              Deaktivieren, wenn Person 2 unter einer anderen Anschrift wohnt.
            </span>
          </span>
        </label>

        {!value.use_main_address && (
          <div className="mt-5 pl-7" data-testid="p2-address-block">
            <AddressBlock
              value={p2Address}
              onChange={onP2AddressChange}
              search={searchPlaces}
              idPrefix="form-p2-address"
              searchPlaceholder="Anschrift von Person 2"
            />
          </div>
        )}
      </div>
    </div>
  );
};

const Field = ({ id, label, value, onChange, type = "text", placeholder = "", className = "" }) => {
  const isTel = type === "tel";
  return (
  <label className={`block ${className}`}>
    <span className="eyebrow text-[#505a74]">{label}</span>
    <input
      type={type}
      inputMode={isTel ? "tel" : undefined}
      pattern={isTel ? "[0-9+\\s\\-()/]*" : undefined}
      value={value || ""}
      data-testid={`form-input-${id}`}
      onChange={(e) => {
        const v = type === "date" ? clipDateYear(e.target.value) : e.target.value;
        onChange(v);
      }}
      max={type === "date" ? "9999-12-31" : undefined}
      placeholder={placeholder}
      className="mt-2 block w-full bg-white border border-[#e8e6df] rounded-sm px-4 py-3 text-[15px] focus:outline-none focus:border-[#0a1128] transition"
    />
  </label>
  );
};
